export default __webpack_public_path__ + "static/media/s-squiggle-144.9c4b8703.svg";